import React from "react";

interface ImageViewerProps {
  showImageModal: boolean;
  setShowImageModal: (value: React.SetStateAction<boolean>) => void;
  modalImageSrc: string;
  modalImageAlt: string;
}

const ImageViewer: React.FC<ImageViewerProps> = ({
  showImageModal,
  setShowImageModal,
  modalImageSrc,
  modalImageAlt,
}) => {
  return (
    <>
      {showImageModal && modalImageSrc && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 z-[1000] flex items-center justify-center"
          onClick={() => setShowImageModal(false)}
        >
          <div
            className="max-w-[72rem] 2xl:max-w-[80rem] max-h-[90vh] p-10 bg-white rounded shadow-lg overflow-auto relative"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="absolute right-2 top-2 z-10">
              <button
                onClick={() => setShowImageModal(false)}
                className="text-gray-500 hover:text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-full p-1 transition"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <img
              src={modalImageSrc}
              alt={modalImageAlt}
              className="max-w-full max-h-[80vh] object-contain mx-auto"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ImageViewer;
